module.exports = __webpack_public_path__ + "static/media/iconsPython.cbd60ba6.gif";